import React, { useMemo, useRef } from 'react';
import classNames from 'classnames';
;
const CarouselIndicator = ({ prefixCls, dotPosition = 'bottom', autoplay = true, length, setKey, currentKey, playInterval, dotType = 'dot', multi, showNumber = 1, style }) => {
    const timer = useRef();
    const extraCount = useMemo(() => {
        return multi ? showNumber : 1;
    }, [multi, showNumber]);
    const key = useMemo(() => {
        if (currentKey >= length + extraCount) {
            return currentKey - length - extraCount;
        }
        if (currentKey < extraCount) {
            return length - extraCount + currentKey;
        }
        return currentKey - extraCount;
    }, [currentKey, extraCount, length]);
    const handleClick = idx => {
        if (currentKey === 0) {
            setKey({ lastKey: 0, currentKey: length });
            clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                setKey({ lastKey: length + 1, currentKey: idx + extraCount });
            });
            return;
        }
        if (currentKey === length + extraCount) {
            setKey({ lastKey: currentKey, currentKey: extraCount });
            clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                setKey({ lastKey: extraCount, currentKey: idx + extraCount });
            });
            return;
        }
        setKey({ lastKey: currentKey, currentKey: idx + extraCount });
    };
    return (<div style={style} className={classNames(`${prefixCls}-indicator`, `${prefixCls}-indicator-${dotType}`, `${prefixCls}-indicator-${dotPosition}`)}>
            {dotType === 'dot'
            ? (<ul>
                        {Array.from({ length }, (_v, k) => (<li onClick={() => handleClick(k)} key={k} className={k === key ? 'active' : ''}>
                                <div className="fill" style={{ transitionDuration: `${k === key && autoplay ? playInterval : 0}ms` }}></div>
                            </li>))}
                    </ul>)
            : (<div>{key + 1}/<span className="total">{length}</span></div>)}
        </div>);
};
export default CarouselIndicator;
